import { render, staticRenderFns } from "./NodeConfig.vue?vue&type=template&id=10b9e7b6&scoped=true&"
import script from "./NodeConfig.vue?vue&type=script&lang=js&"
export * from "./NodeConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b9e7b6",
  null
  
)

export default component.exports